import { useNavigate } from 'react-router';

import { useTranslation } from 'react-i18next';

import { Button, Modal } from '@cfa/react-core';

import { routes } from '@/constants';

interface UnauthorizedModalProps {
  isOpen: boolean;
}

/**
 * UnauthorizedModal
 * Figma node 35944:207979
 * Modal shown when user lacks Leader/Operator/Admin/Stakeholder permissions
 * to add a Read-Only plan.
 */
const UnauthorizedModal: React.FC<UnauthorizedModalProps> = ({ isOpen }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClose = () => {
    navigate(routes.plans.managedPlans);
  };
  return (
    <Modal.Dialog size="md" isOpen={isOpen} onOpenChange={() => handleClose()}>
      <Modal.Content className="text-contrast! px-8! text-base/6! font-normal!">
        <Modal.Title className="text-contrast! text-2xl/8! font-bold!">
          {t('GenericError.unauthorized')}
        </Modal.Title>
        {t('LoadingResourceError.unauthorizedParagraph')}
      </Modal.Content>
      <Modal.Footer>
        <Button
          color="primary"
          className="bg-feedback-error-base!"
          data-testid="UnauthorizedModalCloseButton"
          onPress={handleClose}
          variant="filled"
        >
          {t('Button.returnToHomepage')}
        </Button>
      </Modal.Footer>
    </Modal.Dialog>
  );
};

export default UnauthorizedModal;
